import { gql } from '@grandvisionhq/graphql';

const shoppinglistVariantPricesFragment = gql`
  fragment ShoppinglistVariantPricesFragment on ProductPrices {
    discountedPrice {
      price {
        amount
        currencyCode
      }
    }
    originalPrice {
      amount
      currencyCode
    }
  }
`;
const shoppinglistVariantMediaFragment = gql`
  fragment ShoppinglistVariantMediaFragment on Media {
    images {
      url
    }
  }
`;
const shoppinglistVariantFragment = gql`
  fragment ShoppinglistVariantFragment on Variant {
    ... on AccessoriesVariant {
      sku
      prices {
        ...ShoppinglistVariantPricesFragment
      }
      media {
        ...ShoppinglistVariantMediaFragment
      }
    }
    ... on ContactLensVariant {
      sku
      gan
      prices {
        ...ShoppinglistVariantPricesFragment
      }
      media {
        ...ShoppinglistVariantMediaFragment
      }
    }
    ... on FrameVariant {
      sku
      prices {
        ...ShoppinglistVariantPricesFragment
      }
      media {
        ...ShoppinglistVariantMediaFragment
      }
    }
    ... on LensTypeVariant {
      sku
      prices {
        ...ShoppinglistVariantPricesFragment
      }
      media {
        ...ShoppinglistVariantMediaFragment
      }
    }
    ... on PrescriptionGlassesPackageOptionsVariant {
      sku
      prices {
        ...ShoppinglistVariantPricesFragment
      }
      media {
        ...ShoppinglistVariantMediaFragment
      }
    }
    ... on PrescriptionGlassesPackageVariant {
      sku
      prices {
        ...ShoppinglistVariantPricesFragment
      }
      media {
        ...ShoppinglistVariantMediaFragment
      }
    }
    ... on ReadyReaderVariant {
      sku
      prices {
        ...ShoppinglistVariantPricesFragment
      }
      media {
        ...ShoppinglistVariantMediaFragment
      }
    }
    ... on SolutionVariant {
      gan
      sku
      prices {
        ...ShoppinglistVariantPricesFragment
      }
      media {
        ...ShoppinglistVariantMediaFragment
      }
    }
    ... on SunglassesVariant {
      sku
      prices {
        ...ShoppinglistVariantPricesFragment
      }
      media {
        ...ShoppinglistVariantMediaFragment
      }
    }
  }
  ${shoppinglistVariantMediaFragment}
  ${shoppinglistVariantPricesFragment}
`;

export { shoppinglistVariantFragment };
//# sourceMappingURL=variant.js.map
